<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 w-full max-w-sm p-6">
      <div class="text-center mb-6">
        <div class="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
          <svg class="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
        </div>
        <h1 class="text-2xl font-bold text-gray-900">Área do Entregador</h1>
        <p class="text-sm text-gray-500 mt-1">Digite sua senha para acessar seus pedidos</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Senha</label>
          <input
            v-model="password"
            type="password"
            inputmode="numeric"
            autofocus
            class="w-full border rounded-lg px-4 py-3 text-center text-2xl tracking-widest font-mono focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            placeholder="••••••••"
          >
        </div>
        
        <button
          type="submit"
          :disabled="loading || !password"
          class="w-full px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 font-medium"
        >
          {{ loading ? 'Entrando...' : 'Acessar' }}
        </button>
      </form>
      
      <div v-if="error" class="mt-4 p-3 bg-red-50 text-red-700 text-sm rounded-lg text-center">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { driverAuthApi } from '@/utils/api'

const router = useRouter()
const password = ref('')
const loading = ref(false)
const error = ref('')

const handleLogin = async () => {
  if (!password.value.trim()) return
  
  loading.value = true
  error.value = ''
  
  try {
    const res = await driverAuthApi.login(password.value.trim())
    const { access_token, name, driver_type, driver_index } = res.data
    
    localStorage.setItem('driver_token', access_token)
    localStorage.setItem('driver_name', name || '')
    localStorage.setItem('driver_type', driver_type || '')
    localStorage.setItem('driver_index', driver_index !== null && driver_index !== undefined ? String(driver_index) : '')
    
    router.push('/driver/orders')
  } catch (err: any) {
    error.value = err.response?.data?.detail || 'Senha inválida'
  } finally {
    loading.value = false
  }
}
</script>
